const sign_up_and_sign_in = {
    identifiers_email: 'Адрес электронной почты',
    identifiers_phone: 'Номер телефона',
    identifiers_username: 'Имя пользователя',
    identifiers_email_or_sms: 'Адрес электронной почты или номер телефона',
    identifiers_none: 'Не применимо',
    and: 'и',
    or: 'или',
    sign_up: {
        title: 'РЕГИСТРАЦИЯ',
        sign_up_identifier: 'Идентификатор регистрации',
        identifier_description: 'Все выбранные идентификаторы регистрации требуются при создании новой учетной записи.',
        sign_up_authentication: 'Настройки аутентификации для регистрации',
        verification_tip: 'Пользователи должны подтвердить электронную почту или номер телефона, которые вы настроили, введя код подтверждения при регистрации.',
        authentication_description: 'Все выбранные действия будут обязательны для выполнения пользователем.',
        set_a_password_option: 'Создайте пароль',
        verify_at_sign_up_option: 'Подтвердить при регистрации',
        social_only_creation_description: '(Применяется только к созданию учетной записи в социальных сетях)',
        collect_user_profile: 'Сбор профиля пользователя',
        add_profile_fields: 'Добавить поля профиля',
        profile_fields_hint: {
            not_in_list: 'Нет в списке?',
            set_up: 'Настройте',
            go_to: 'другие поля профиля сейчас.',
        },
    },
    sign_in: {
        title: 'ВХОД',
        sign_in_identifier_and_auth: 'Идентификатор и настройки аутентификации для входа',
        description: 'Пользователи могут войти, используя любой из доступных вариантов.',
        add_sign_in_method: 'Добавить способ входа',
        add_sign_up_method: 'Добавить способ регистрации',
        password_auth: 'Пароль',
        verification_code_auth: 'Код подтверждения',
        auth_swap_tip: 'Переставьте варианты ниже, чтобы определить, какой появится первым в потоке.',
        require_auth_factor: 'Вы должны выбрать хотя бы один фактор аутентификации.',
        forgot_password: 'Забыли пароль',
        forgot_password_description: 'Пользователи могут сбросить пароль, используя любой доступный метод подтверждения.',
        add_verification_method: 'Добавить метод подтверждения',
        email_verification_code: 'Код подтверждения по электронной почте',
        phone_verification_code: 'Код подтверждения по телефону',
    },
    social_sign_in: {
        title: 'ВХОД С ПОМОЩЬЮ СОЦИАЛЬНЫХ СЕТЕЙ',
        social_sign_in: 'Вход через социальные сети',
        description: 'В зависимости от обязательного идентификатора, который вы настроили, ваш пользователь может быть попрошен предоставить идентификатор при регистрации через социальный коннектор.',
        add_social_connector: 'Добавить социальный коннектор',
        set_up_hint: {
            not_in_list: 'Не найден в списке?',
            set_up_more: 'Настроить',
            go_to: 'другие социальные коннекторы.',
        },
        settings_title: 'Опыт входа через социальные сети',
        automatic_account_linking: 'Автоматически связывать учетные записи с одинаковым идентификатором',
        automatic_account_linking_tip: 'Когда включено, если пользователь входит с новой социальной идентичностью и есть ровно одна существующая учетная запись с таким же идентификатором (например, адрес электронной почты), Logto автоматически свяжет социальную идентичность с этой учетной записью. Пользователь не будет запрашиваться с выбором связать учетные записи.',
        required_sign_up_identifiers: 'Требовать от пользователей предоставления отсутствующего идентификатора регистрации',
        required_sign_up_identifiers_tip: 'Когда включено, пользователи, входящие через социальных провайдеров, должны заполнить любые отсутствующие необходимые идентификаторы регистрации (например, адрес электронной почты) перед завершением входа. \n\nЕсли отключено, пользователи могут продолжить без предоставления отсутствующих идентификаторов, даже если социальная учетная запись не синхронизировала их.',
    },
    passkey_sign_in: {
        title: 'ВХОД С ПОМОЩЬЮ PASSKEY',
        passkey_sign_in: 'Вход с помощью Passkey',
        enable_passkey_sign_in_description: 'Позволяет пользователям быстро и безопасно получать доступ к приложению через Passkey (WebAuthn), используя биометрию или ключ безопасности и т.д.',
        prompts: 'Подсказки Passkey',
        show_passkey_button: 'Показывать кнопку "Продолжить с Passkey" на странице входа',
        show_passkey_button_tip: 'Отключение кнопки "Продолжить с Passkey" делает процесс входа основанным на идентификаторе, показывая варианты пароля и Passkey на следующем шаге.',
        allow_autofill: 'Разрешить подсказки и автозаполнение зарегистрированных Passkey в полях идентификатора',
    },
    tip: {
        set_a_password: 'Уникальный пароль для вашего имени пользователя является обязательным.',
        verify_at_sign_up: 'В настоящее время мы поддерживаем только подтвержденный электронный адрес. Ваша база пользователей может содержать большое количество адресов электронной почты низкого качества, если не производится проверка.',
        password_auth: 'Это необходимо, так как вы включили опцию установки пароля в процессе регистрации.',
        verification_code_auth: 'Это необходимо, так как вы включили только опцию предоставления кода подтверждения при регистрации. Вы можете снять флажок, когда установка пароля разрешена в процессе регистрации.',
        email_mfa_enabled: 'Код подтверждения по электронной почте уже включен для MFA, поэтому его нельзя повторно использовать в качестве основного метода входа для безопасности.',
        phone_mfa_enabled: 'Код подтверждения по телефону уже включен для MFA, поэтому его нельзя повторно использовать в качестве основного метода входа для безопасности.',
        delete_sign_in_method: 'Это необходимо, так как вы выбрали {{identifier}} в качестве обязательного идентификатора.',
        password_disabled_notification: 'Опция "Создайте пароль" отключена для регистрации по имени пользователя, что может помешать пользователям входить в систему. Подтвердите, чтобы продолжить сохранение.',
    },
    advanced_options: {
        title: 'ДОПОЛНИТЕЛЬНЫЕ ОПЦИИ',
        enable_single_sign_on: 'Включить единую авторизацию (SSO) для предприятий',
        enable_single_sign_on_description: 'Включить возможность входа пользователей в систему с помощью единой авторизации с использованием их корпоративных учетных данных.',
        single_sign_on_hint: {
            prefix: 'Перейти в раздел ',
            link: '"Единая авторизация для предприятий"',
            suffix: ' для настройки дополнительных корпоративных коннекторов.',
        },
        show_sso_branding_before_email_match: 'Показывать названия и логотипы SSO-коннекторов до совпадения домена электронной почты',
        show_sso_branding_before_email_match_description: 'Если включено, названия и логотипы SSO-коннекторов включаются в публичную конфигурацию входа до совпадения домена электронной почты. Если выключено, они показываются только после совпадения.',
        enable_user_registration: 'Включить регистрацию пользователей',
        enable_user_registration_description: 'Включить или отключить регистрацию пользователей. После отключения пользователи все равно могут быть добавлены через консоль администратора, но больше создавать учетные записи через пользовательский интерфейс регистрации не могут.',
        unknown_session_redirect_url: 'URL перенаправления неизвестной сессии',
        unknown_session_redirect_url_tip: 'Иногда Logto может не распознать пользовательскую сессию на странице входа, например, когда сессия истекает или пользователь создает закладку или делится ссылкой на вход. По умолчанию появляется ошибка 404 "неизвестная сессия". Чтобы улучшить пользовательский опыт, установите URL для перенаправления пользователей обратно в ваше приложение и перезапуска авторизации.',
    },
    username_policy: {
        title: 'Политика имени пользователя',
        description: 'Настройте требования к имени пользователя, включая длину, разрешённые символы и чувствительность к регистру.',
        manage_button: 'Управлять',
        modal_title: 'Политика имени пользователя',
        modal_description: 'Настройте требования к имени пользователя для ваших конечных пользователей.',
        length: {
            title: 'Длина имени пользователя',
            minimum: 'Минимум',
            maximum: 'Максимум',
            min_greater_than_max: 'Минимальная длина не может превышать максимальную длину.',
        },
        allowed_chars: {
            title: 'Разрешённые типы символов',
            uppercase: 'Прописные буквы (A-Z)',
            lowercase: 'Строчные буквы (a-z)',
            numbers: 'Цифры (0-9)',
            underscore: 'Подчёркивания (_)',
            no_valid_leading_char: 'Использование только цифр не допускается. Включите хотя бы один из вариантов: прописные буквы, строчные буквы или подчёркивания.',
            no_char_selected: 'Выберите хотя бы один тип символов.',
        },
        case_sensitive: {
            title: 'Имена пользователей с учётом регистра',
            description: 'Рассматривать прописные и строчные буквы как разные. «user123» и «User123» считаются разными именами пользователей.',
        },
        case_conflicts: {
            title: 'Обнаружены существующие конфликты имён пользователей',
            description: 'Некоторые имена пользователей будут конфликтовать, если отключить учёт регистра. Прежде чем сохранить, устраните {{count}} конфликтующих групп ниже.',
            sample_title: 'Конфликтующие имена пользователей',
        },
    },
};
export default Object.freeze(sign_up_and_sign_in);
